import { defineStore } from 'pinia';
import api from '@/common/utils/api';
import ability from '@/common/ability';
import useAppModeStore from '@/common/store/pinia/appMode';

export enum ActionsMap {
  GET = 'read',
  POST = 'create',
  DELETE = 'delete',
  PATCH = 'update',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  PUT = 'update'
}

export interface MetaInfo {
  methods: ActionsMap[],
  name: string,
  url: string
}

export interface AbilityRule {
  subject: string,
  action: string,
  inverted?: boolean
}

export const usePermissionsStore = defineStore('permissions', {
  state: () => ({
    permissionsAreLoaded: false
  }),
  actions: {
    async fetchAuthMeta() {
      const appModeStore = useAppModeStore();
      const res: FetchResponse<Record<string, MetaInfo>> = await api.get('/api/v2/meta');
      const rules: AbilityRule[] = [];

      Object.values(res.data)
        .forEach(resource => {
          const abilities: string[] = [];
          resource.methods.forEach(method => {
            if (ActionsMap[method]) {
              rules.push({
                subject: resource.name,
                action: ActionsMap[method]
              });
              abilities.push(ActionsMap[method]);
            }
          });

          if (['delete', 'update'].every(x => abilities.includes(x))) {
            rules.push({
              subject: resource.name,
              action: 'change'
            });
          }
        });

      ability.update([
        ...rules,
        ...appModeStore.preset.abilityRules
      ]);
      this.permissionsAreLoaded = true;
      return rules;
    }
  }
});

export default usePermissionsStore;
